import { CSSProperties } from 'react';
import { CssPropertiesFormattingConverterObject } from './CssPropertiesFormattingConverterObject';
import { JQueryFormattingConverterObject } from './JQueryFormattingConverterObject';
import { TextStyleFormattingConverters } from './TextStyleFormattingConverters';

export class TextStyleFormattingConvertersFactory {
  static cleanUpFontFamilyStylingForCSSProperties(cssProperties: CSSProperties): void {
    TextStyleFormattingConverters.cleanUpFontFamilyStyling(new CssPropertiesFormattingConverterObject(cssProperties));
  }

  static cleanUpFontFamilyStylingForJQuery(jQueryObject: JQuery.PlainObject): void {
    TextStyleFormattingConverters.cleanUpFontFamilyStyling(new JQueryFormattingConverterObject(jQueryObject));
  }
}
